import { catalog, allowed, findReport } from './gestaoPolicy'
export function relatoriosAccess(globalState) {
  const permissions = globalState.permissionsLoaded === true ? globalState.userPermissions || [] : []
  const resources = catalog.filter(item => allowed(permissions, item))
  return {
    gestao: permissions.includes('menu_gestao') || resources.length > 0,
    relatorios: resources.some(item => item.kind === 'relatorio'),
    graficos: resources.some(item => item.kind === 'grafico'),
    grafico(key) { return resources.some(item => item.kind === 'grafico' && item.key === key) },
    grupoGraficos(category) { return resources.some(item => item.kind === 'grafico' && item.category === category) },
    permite(categoria, key) { return allowed(permissions, findReport(key)) },
  }
}

export function gestaoRouteAllowed(state, route) {
  const access = relatoriosAccess(state)
  const path = route.path.replace(/\/$/, '')
  if (!path.startsWith('/gestao/')) return true
  const chartGroup = { financeiros: 'Financeiros', operacionais: 'Operacionais', comerciais: 'Comerciais' }[path.split('/')[3]]
  if (path.startsWith('/gestao/graficos/')) return !!chartGroup && access.grupoGraficos(chartGroup)
  if (path === '/gestao/relatorios') return access.relatorios
  const aliases = {
    'cadastrais/aniversariantes': 'alunos-aniversariantes', 'cadastrais/ativos': 'alunos-ativos',
    'despesas/periodo': 'despesas-por-periodo', 'despesas/a-pagar': 'despesas-a-pagar',
    'despesas/pagas-pagamento': 'despesas-pagas-por-pagamento', 'despesas/pagas-vencimento': 'despesas-pagas-por-vencimento',
    'despesas/analise-refil': 'analise-por-refil', 'financeiros/fechamento-diario': 'fechamento-diario',
  }
  if (path.startsWith('/gestao/relatorios/print/')) return access.permite('', route.params.reportKey)
  return access.permite('', aliases[path.replace('/gestao/relatorios/', '')])
}
